module.exports = __webpack_public_path__ + "media/images/favicon/primary/ms-icon-70x70-f7c3532cc4efa4b780351f4f2ec85410.png";